<template>
  <div class="box historique">
    <div class="columns">
      <div class="column">
        <p class="title has-text-black is-5 has-text-weight-semibold">Historique rapide</p>
      </div>
    </div>
    <v-client-table
      ref="tableListe"
      :data="commandesRapides"
      :columns="columns"
      :options="options">
      <div slot="dateCommande" slot-scope="props">
        {{ formatDate(props.row.dateCommande) }}
      </div>
      <div slot="montantHt" slot-scope="props">
        <div class="is-pulled-right">{{ formatMontant(props.row.montantHt) }}</div>
      </div>
      <div slot="cmdEtat" slot-scope="props">
        {{ formatEtat(props.row.cmdEtat) }}
      </div>
    </v-client-table>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import { COMMANDE_ETAT } from '@/components/mesOpportunites/configuration/commandeConf';

const Client = createNamespacedHelpers('client');

export default {
  name: 'historique',
  data() {
    return {
      trad: {
        cmdCode: 'Code',
        cmdEtat: 'Etat',
        dateCommande: 'Date commande',
        montantHt: 'Montant HT',
      },
    };
  },
  computed: {
    ...Client.mapGetters({
      commandesRapides: 'commandesRapides',
    }),
    columns() {
      return ['cmdCode', 'cmdEtat', 'dateCommande', 'montantHt'];
    },
    options() {
      return {
        headings: {
          cmdCode: this.trad.cmdCode,
          cmdEtat: this.trad.cmdEtat,
          dateCommande: this.trad.dateCommande,
          montantHt: this.trad.montantHt,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        texts: TEXTS,
      };
    },
  },
  methods: {
    formatEtat(etat) {
      return COMMANDE_ETAT[etat].text;
    },
    formatDate(date) {
      return moment(date).format('L');
    },
    formatMontant(montant) {
      return parseFloat(montant).toLocaleString(undefined,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/information/historique.vue